<template>
    <b-tab title-link-class="p-0" lazy>
        <template v-slot:title>
            <b-nav-item-dropdown>
                <template slot="button-content">
                    <i class="cus-folder-picture"></i>
                    Documents
                </template>

                <b-dropdown-item
                    @click="displayList(DOCUMENTTYPES.ATTACHMENTS)"
                >
                    <i class="cus-page-attach"></i>View Attachments
                    <span v-if="counts.attachment">
                        ({{ counts.attachment }})
                    </span>
                </b-dropdown-item>

                <b-dropdown-item
                    v-if="_hasAccess('client.letter.view')"
                    @click="displayList(DOCUMENTTYPES.LETTERS)"
                >
                    <i class="cus-page-white-text"></i>View Letters
                    <span v-if="counts.letter"> ({{ counts.letter }}) </span>
                </b-dropdown-item>

                <b-dropdown-item @click="displayList(DOCUMENTTYPES.WEBFORMS)">
                    <i class="cus-application-form-edit"></i>View Forms
                    <span v-if="counts.webform"> ({{ counts.webform }}) </span>
                </b-dropdown-item>

                <b-dropdown-item
                    @click="displayList(DOCUMENTTYPES.CERTIFICATES)"
                >
                    <i class="cus-page-white-medal"></i>View Certificates
                    <span v-if="counts.certificate">
                        ({{ counts.certificate }})
                    </span>
                </b-dropdown-item>

                <div v-if="statusActive" class="dropdown-divider"></div>

                <b-dropdown-item
                    v-if="
                        _hasAccess('client.attachment.create') && statusActive
                    "
                    @click.stop="openModal('modalNewAttachment')"
                >
                    <i class="cus-add"></i> New Attachment
                </b-dropdown-item>

                <b-dropdown-item
                    v-if="statusActive && _hasAccess('client.letter.create')"
                    @click.stop="openModal('modalNewLetter')"
                >
                    <i class="cus-add"></i> New Letter
                </b-dropdown-item>

                <b-dropdown-item
                    v-if="statusActive"
                    @click.stop="openModal('modalNewWebform')"
                >
                    <i class="cus-add"></i> New Form
                </b-dropdown-item>
            </b-nav-item-dropdown>
        </template>

        <b-card-text>
            <attachments
                v-if="selectedOption == DOCUMENTTYPES.ATTACHMENTS"
                @updateCounts="updateCounts"
                :key="keyview"
                :clientName="clientName"
            />
            <letters
                v-if="selectedOption == DOCUMENTTYPES.LETTERS"
                @updateCounts="updateCounts"
                :key="keyview"
            />
            <webforms
                v-if="
                    selectedOption == DOCUMENTTYPES.WEBFORMS &&
                    !_.isEmpty(client)
                "
                @updateCounts="updateCounts"
                :key="keyview"
                module="client"
                :clientId="client.id"
            />
            <certificates
                v-if="selectedOption == DOCUMENTTYPES.CERTIFICATES"
                @updateCounts="updateCounts"
                :key="keyview"
                :client="client"
            />
        </b-card-text>
    </b-tab>
</template>
<script>
import ClientDocument from "@/services/client-documents";
import Attachments from "@/components/client-documents/document-list-attachments";
import Letters from "@/components/client-documents/document-list-letters";
import Webforms from "@/components/webform/document-list-webforms";
import Certificates from "@/components/client-certificates/document-list-certificates";
import AccountService from "@/services/account.js";

const DOCUMENTTYPES = {
    ATTACHMENTS: "ATTACHMENTS",
    LETTERS: "LETTERS",
    WEBFORMS: "WEBFORMS",
    CERTIFICATES: "CERTIFICATES"
};

export default {
    props: {
        clientName: {
            type: String
        }
    },
    components: {
        Attachments,
        Letters,
        Webforms,
        Certificates
    },
    mounted() {
        this.getTabCounts();
    },
    data() {
        return {
            keyview: 0,
            selectedOption: DOCUMENTTYPES.ATTACHMENTS,
            counts: {},
            DOCUMENTTYPES
        };
    },
    computed: {
        client() {
            return this.$store.state.client.client_details;
        },
        statusActive() {
            return this.$store.getters["client/statusActive"];
        }
    },
    methods: {
        getTabCounts() {
            ClientDocument.getTabCounts(
                this.$store.state.client.client_id
            ).then(res => {
                if (res && res.meta) {
                    this.updateCounts({
                        all: res.meta.count.all_count.toString(),
                        attachment: res.meta.count.attachment_count.toString(),
                        letter: res.meta.count.letter_count.toString(),
                        webform: res.meta.count.webform_count.toString(),
                        certificate: res.meta.count.certificate_count.toString()
                    });
                }
            });
        },
        displayList(code) {
            this.keyview += 1; // force re-render if same menu item is selected
            this.selectedOption = code;
        },
        updateCounts({ all, attachment, letter, webform, certificate }) {
            this.counts = {
                all: all || 0,
                attachment: attachment || 0,
                letter: letter || 0,
                webform: webform || 0,
                certificate: certificate || 0
            };
        },
        openModal(ref) {
            let params = {};

            if (ref === "modalNewAttachment") {
                params = {
                    module: this.MODULE.CLIENT,
                    client_id: this.$store.state.client.client_id
                };
            }

            let parentRefs = this.$parent.$parent.$refs;
            parentRefs[ref].open(params);
        }
    }
};
</script>
